// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* General row styling */
.listContainer {
	overflow: auto;
	display: flex;
	flex-direction: column;
	flex: auto;
	max-height: 40vh;
}

.listrow {
    display: flex;
    align-items: center;
    padding: 5px;
    border-bottom: 1px solid #ddd;
}

.listrow:nth-child(even) {
    background-color: #f9f9f9;
}

.listrow:nth-child(odd) {
    background-color: #e9e9e9;
}

.listrowselected {
	background-color: lightyellow !important;
}

.listid {
	margin-right: 10px;
    flex: 0.5 1 auto;
    padding: 5px;
}

/* Flex layout for the row elements */
.listdesc {
    flex: 5 1 auto;
    padding: 5px;
}

.listinput[type="text"] {
    flex: 1 1 auto;
    padding: 5px;
    margin-right: 10px;
	width: 3vw;
}

.listactions {
    flex: 2 1 auto;
    display: flex;
    gap: 10px;
}

/* Button styling */
.listbutton {
    margin: 5px;
    padding: 5px;
    border: 1px solid lightgray;
    border-radius: 3px;
    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.12);
    display: inline-flex;
    justify-content: center;
    min-width: 25px;
    background-color: white;
    cursor: pointer;
}

.listbutton:hover {
    background-color: #0056b3;
}

/* Delete button specific styling */
.delete {
    background-color: #dc3545;
}

.delete:hover {
    background-color: #c82333;
}

.hidebuttons {
	display: none;
}

.listcol {
	display: flex;
	flex-direction: column;
}
.listcolHeader{
	display: flex;
	flex-direction: row;
	justify-content: center;
	align-items: center;
	height: 1vh;
	border-bottom: 1px solid lightgrey;
}
.listColBody{
	display: flex;
	flex-direction: column;
	justify-content: center;
	align-items: center;
}`, "",{"version":3,"sources":["webpack://./src/project/modules/list/list.module.css"],"names":[],"mappings":"AAAA,wBAAwB;AACxB;CACC,cAAc;CACd,aAAa;CACb,sBAAsB;CACtB,UAAU;CACV,gBAAgB;AACjB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,YAAY;IACZ,6BAA6B;AACjC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;CACC,wCAAwC;AACzC;;AAEA;CACC,kBAAkB;IACf,gBAAgB;IAChB,YAAY;AAChB;;AAEA,qCAAqC;AACrC;IACI,cAAc;IACd,YAAY;AAChB;;AAEA;IACI,cAAc;IACd,YAAY;IACZ,kBAAkB;CACrB,UAAU;AACX;;AAEA;IACI,cAAc;IACd,aAAa;IACb,SAAS;AACb;;AAEA,mBAAmB;AACnB;IACI,WAAW;IACX,YAAY;IACZ,2BAA2B;IAC3B,kBAAkB;IAClB,+CAA+C;IAC/C,oBAAoB;IACpB,uBAAuB;IACvB,eAAe;IACf,uBAAuB;IACvB,eAAe;AACnB;;AAEA;IACI,yBAAyB;AAC7B;;AAEA,mCAAmC;AACnC;IACI,yBAAyB;AAC7B;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;CACC,aAAa;AACd;;AAEA;CACC,aAAa;CACb,sBAAsB;AACvB;AACA;CACC,aAAa;CACb,mBAAmB;CACnB,uBAAuB;CACvB,mBAAmB;CACnB,WAAW;CACX,kCAAkC;AACnC;AACA;CACC,aAAa;CACb,sBAAsB;CACtB,uBAAuB;CACvB,mBAAmB;AACpB","sourcesContent":["/* General row styling */\r\n.listContainer {\r\n\toverflow: auto;\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tflex: auto;\r\n\tmax-height: 40vh;\r\n}\r\n\r\n.listrow {\r\n    display: flex;\r\n    align-items: center;\r\n    padding: 5px;\r\n    border-bottom: 1px solid #ddd;\r\n}\r\n\r\n.listrow:nth-child(even) {\r\n    background-color: #f9f9f9;\r\n}\r\n\r\n.listrow:nth-child(odd) {\r\n    background-color: #e9e9e9;\r\n}\r\n\r\n.listrowselected {\r\n\tbackground-color: lightyellow !important;\r\n}\r\n\r\n.listid {\r\n\tmargin-right: 10px;\r\n    flex: 0.5 1 auto;\r\n    padding: 5px;\r\n}\r\n\r\n/* Flex layout for the row elements */\r\n.listdesc {\r\n    flex: 5 1 auto;\r\n    padding: 5px;\r\n}\r\n\r\n.listinput[type=\"text\"] {\r\n    flex: 1 1 auto;\r\n    padding: 5px;\r\n    margin-right: 10px;\r\n\twidth: 3vw;\r\n}\r\n\r\n.listactions {\r\n    flex: 2 1 auto;\r\n    display: flex;\r\n    gap: 10px;\r\n}\r\n\r\n/* Button styling */\r\n.listbutton {\r\n    margin: 5px;\r\n    padding: 5px;\r\n    border: 1px solid lightgray;\r\n    border-radius: 3px;\r\n    box-shadow: 2px 2px 2px 2px rgba(0, 0, 0, 0.12);\r\n    display: inline-flex;\r\n    justify-content: center;\r\n    min-width: 25px;\r\n    background-color: white;\r\n    cursor: pointer;\r\n}\r\n\r\n.listbutton:hover {\r\n    background-color: #0056b3;\r\n}\r\n\r\n/* Delete button specific styling */\r\n.delete {\r\n    background-color: #dc3545;\r\n}\r\n\r\n.delete:hover {\r\n    background-color: #c82333;\r\n}\r\n\r\n.hidebuttons {\r\n\tdisplay: none;\r\n}\r\n\r\n.listcol {\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n}\r\n.listcolHeader{\r\n\tdisplay: flex;\r\n\tflex-direction: row;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n\theight: 1vh;\r\n\tborder-bottom: 1px solid lightgrey;\r\n}\r\n.listColBody{\r\n\tdisplay: flex;\r\n\tflex-direction: column;\r\n\tjustify-content: center;\r\n\talign-items: center;\r\n}"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
